import { ModelType, ParsedLegifranceLink } from '@livv/models';
import { FC } from 'react';
import OfficialSource from './OfficialSource';
import PreviousTexts from './PreviousTexts';
import Citations from '@components/Citations';

interface SideContentProps {
    articleId: string;
    lienCitations: ParsedLegifranceLink[];
    lienConcordes: ParsedLegifranceLink[];
    title: string;
}

const SideContent: FC<SideContentProps> = ({ articleId, lienCitations, lienConcordes, title }) => (
    <>
        {Boolean(lienCitations.length) && (
            <Citations
                codeArticleCitations={lienCitations}
                documentId={articleId}
                modelType={ModelType.LAW_TEXT}
                title={title}
            />
        )}
        {Boolean(lienConcordes.length) && <PreviousTexts lienConcordes={lienConcordes} />}
        <OfficialSource />
    </>
);

export default SideContent;
